import { connect } from 'react-redux';
import queryString from 'query-string';
import { SignupPage } from '../SignupPage';
import { submitCreateAccountForm, showRequestResetPassword } from '../../user';

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: data => {
    const {
      location: { search },
    } = ownProps;
    const { ref } = queryString.parse(search);
    dispatch(
      submitCreateAccountForm(data, null, {
        doAddToEmailList: true,
        ref,
      })
    );
  },
  onClickRequestResetPassword: () =>
    dispatch(showRequestResetPassword('Forgot Password')),
});

const mapStateToProps = ({ routing }) => ({
  routing,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignupPage);
